// extracted by mini-css-extract-plugin
export default {"container":"_1x7KYytQqIEFG_wAwa2RxK","heading":"_1ojjVeUrxEK7Hm7ZEFYIdc","buttonContainer":"CSuXq9qbnR8OvAq6zgHQG","extraAction":"_4Pz8RvGQEosQNeWjOemzH"};